import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ScrollToTop from "./scroll_to_top";
import HeadSEO from "../layouts/tradnity/headSEO";
import "./AboutPage.css";

import aboutTopBanner from "../../assets/images/about-top-banner.png";
import aboutStoryBanner from "../../assets/images/aboutS.png";
import aboutBottomBanner from "../../assets/images/aboutT.png";

/* ── Value icons (Vector SVGs matching brand luxury gold theme) ── */
const IconDiamond = () => (
  <svg
    viewBox="0 0 40 40"
    width="38"
    height="38"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10 6h20l7 10-17 18L3 16l7-10z" />
    <path d="M3 16h34" />
    <path d="M10 6l7 10-7 18" />
    <path d="M30 6l-7 10 7 18" />
    <path d="M17 16l3 18" />
  </svg>
);

const IconCraft = () => (
  <svg
    viewBox="0 0 40 40"
    width="38"
    height="38"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 6c-2 0-3.5 1.5-4 3.5L16 14l-2.5-2.5c-1.5-1.5-3.5-.8-4.2.7s-.2 3.5 1.2 4.8l6.5 6c1.5 1.5 3.5 2.2 5.5 2.2h2c3.5 0 6.5-2.8 6.5-6.3v-4.4c0-2-1.5-3.5-3.5-3.5s-3 1.5-3 1.5V9.5C24.5 7.5 23.5 6 22 6z" />
    <circle cx="20" cy="18" r="1.5" fill="#F5B96D" />
  </svg>
);

const IconTimeless = () => (
  <svg
    viewBox="0 0 40 40"
    width="38"
    height="38"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 35s13-6.5 13-16V9l-13-5-13 5v10c0 9.5 13 16 13 16z" />
  </svg>
);

const IconHeart = () => (
  <svg
    viewBox="0 0 40 40"
    width="38"
    height="38"
    fill="none"
    stroke="#F5B96D"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M32.5 8.5a8 8 0 0 0-11.3 0L20 9.7l-1.2-1.2a8 8 0 0 0-11.3 11.3l1.2 1.2L20 32.5l11.3-11.3 1.2-1.2a8 8 0 0 0 0-11.5z" />
  </svg>
);

const VALUES = [
  {
    icon: <IconDiamond />,
    title: "PREMIUM QUALITY",
    desc: "Only the finest materials for lasting beauty.",
  },
  {
    icon: <IconCraft />,
    title: "EXPERT CRAFTSMANSHIP",
    desc: "Handcrafted with precision and care.",
  },
  {
    icon: <IconTimeless />,
    title: "TIMELESS DESIGNS",
    desc: "Classics and trends, perfectly balanced.",
  },
  {
    icon: <IconHeart />,
    title: "CUSTOMER FIRST",
    desc: "Your satisfaction is our priority.",
  },
];

class AboutPage extends Component {
  render() {
    return (
      <div className="ab-root">
        <ScrollToTop />
        <HeadSEO title="About Us | SHANZ BY SHANZAY" />

        {/* ── 1. TOP HERO BANNER (Full Image) ── */}
        <section className="ab-banner-section">
          <div className="ab-banner-inner">
            <img
              src={
                aboutTopBanner ||
                `${process.env.PUBLIC_URL}/about-top-banner.png`
              }
              alt="About SHANZ - More Than Just Jewellery"
              className="ab-full-banner-img"
              loading="eager"
            />
          </div>
        </section>

        {/* ── 2. STORY BANNER (Full Image) ── */}
        <section className="ab-banner-section">
          <div className="ab-banner-inner">
            <img
              src={
                aboutStoryBanner || `${process.env.PUBLIC_URL}/aboutS.png`
              }
              alt="Our Story - A Vision Born From Passion"
              className="ab-full-banner-img"
              loading="lazy"
            />
          </div>
        </section>

        {/* ── 3. OUR VALUES (Built-in interactive text & 4 cards) ── */}
        <section className="ab-values">
          <div className="ab-eyebrow ab-eyebrow--center">
            <span className="ab-eyebrow-line" />
            <span className="ab-eyebrow-text">OUR VALUES</span>
            <span className="ab-eyebrow-line" />
          </div>
          <h2 className="ab-values-h2">
            WHAT MAKES US <em className="ab-values-em">DIFFERENT</em>
          </h2>
          <div className="ab-values-grid">
            {VALUES.map((v, i) => (
              <div key={i} className="ab-val-card">
                <div className="ab-val-icon">{v.icon}</div>
                <h4 className="ab-val-title">{v.title}</h4>
                <p className="ab-val-desc">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── 4. BOTTOM CRAFT BANNER (Full Image) ── */}
        <section className="ab-banner-section">
          <div className="ab-banner-inner">
            <Link
              to={`${process.env.PUBLIC_URL}/products`}
              className="ab-banner-link"
              aria-label="Explore Collections"
            >
              <img
                src={
                  aboutBottomBanner || `${process.env.PUBLIC_URL}/aboutT.png`
                }
                alt="Timeless Elegance in Every Detail - Explore Collections"
                className="ab-full-banner-img"
                loading="lazy"
              />
            </Link>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  about: (state.images?.sliderBannner || []).filter(
    (d) => d.title === "About Us"
  ),
  about_side: (state.images?.sliderBannner || []).filter(
    (d) => d.title === "About Side Img"
  ),
});

export default connect(mapStateToProps)(AboutPage);
